import { Subject } from "rxjs";
import { Observer } from "src/app/model/observer";
import { ObjectUtil } from "../ObjectUtil";

export class TableObserverUser {

  static propCheck = 'checked';

  private elements: Array<Observer>;
  private elementSelecteds: Array<Observer>;
  public observerUsers = new Subject<Array<Observer>>();

  constructor() {
      this.elements = [];
  }

  updateElement(el: any, obj: {}) {
      const indexElement = this.elements.indexOf(el);
      Object.assign(this.elements[indexElement], obj);
      this.observerUsers.next(this.elements);
  }

  updateElements(ev: any) {
      this.elements.forEach(el => Object.assign(el, ev));
      this.observerUsers.next(this.elements);
  }

  updateByElementId(ev: any) {
    this.elements.some(el => {
      if ((el.id) && (el.id === ev.id)) {
        Object.assign(el, ev);
      }
    });
  }

  getElementOptions(element): any {
      return { span: '', value: element[TableObserverUser.propCheck] };
  }

  getElementSelected():  Array<Observer> {
    return this.elementSelecteds;
  }

  getList(filter) {
      this.observerUsers.next(this.elements.filter(item =>
          Object.keys(item).some(
              k =>
                  item[k] != null &&
                  item[k]
                      .toString()
                      .toLowerCase()
                      .includes(filter.toLowerCase())
          )
      ));
  }

  removeEl(user: Observer) {
      const index = this.elements.indexOf(user);
      this.elements.splice(index, 1);
      this.observerUsers.next(this.elements);
  }

  removeAllElements() {
    this.elements = [];
    this.observerUsers.next(this.elements);
  }

  addEl(user: Observer) {
      this.elements.push(user);
      this.observerUsers.next(this.elements);
  }

  addList(users: Array<Observer>) {
      this.elements = Object.assign([], users);
      this.observerUsers.next(this.elements);
  }

  addListSelecteds(users: Array<Observer>) {
    this.elementSelecteds = Object.assign([], users);
    this.observerUsers.next(this.elementSelecteds);
  }

  mergeList(users: Array<Observer>) {
      let counter = 0;
      users.forEach(user => {
          const isNewUser = this.mergeById(user);
          if (isNewUser) {
              counter++;
          }
      });
      this.observerUsers.next(this.elements);
      return counter;
  }

  private mergeById(user: Observer) {
      let findUser;
      this.elements.some(el => {
          if (el.id === user.id) {
              findUser = Object.assign(el, user);
              return true;
          }
      });
      if ((!(findUser)) || ObjectUtil.isEmpty(findUser)) {
          this.elements.push(user);
          return true;
      }
      return false;
  }

  anyCheckedElement(): boolean {
      return this.elements.anyChecked(TableObserverUser.propCheck);
  }

  countCheckedElements(): number {
      if(!this.elementSelecteds) {
        return 0;
      }

      return this.elementSelecteds.filter(el => el[TableObserverUser.propCheck]).length;
  }

  deselectAll() {
      this.elementSelecteds = [];
      this.elements.forEach(el => el[TableObserverUser.propCheck] = false);
      this.observerUsers.next(this.elements);
  }

  selectAll() {
      this.elementSelecteds = [];
      this.elements.forEach(el => el[TableObserverUser.propCheck] = true);
      this.observerUsers.next(this.elements);
      this.elementSelecteds = this.elements.filter(el => el[TableObserverUser.propCheck]);
  }

  contains(prop, value) {
      return this.elements.some(el => el[prop] == value);
  }

  changeElementPropertyValue(el, propName, propNewValue) {
      const indexElement = this.elements.indexOf(el);
      this.elements[indexElement][propName] = propNewValue;
      this.observerUsers.next(this.elements);
  }
}
